module.exports = __webpack_public_path__ + "img/11.a7667d02.jpg";